<template class="pendencyBody">
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>

    <b-card class="mainCardBG">
      <b-row>
        <b-navbar-nav>

        </b-navbar-nav>

        <b-col md="2">
          <h5 class="page-title mb-2">
            <b>UnUsed Booking</b>
          </h5>
        </b-col>
        <b-col md="3">
          <label for="dateDropdown">SI Due Date:</label>
          <model-list-select :list="next7Days" id="SiDueDateFilter" @input="debounceSearch"
            v-model="Filter.SiDueDateFilter" option-value="value" option-text="label"
            placeholder="Select SI Due Date" />

        </b-col>
        <b-col md="3">
          <label for="dateDropdown">TR Due Date:</label>
          <model-list-select :list="next7Days" id="TrDueDateFilter" @input="debounceSearch"
            v-model="Filter.TrDueDateFilter" option-value="value" option-text="label"
            placeholder="Select TR Due Date" />
        </b-col>
        <b-col md="3">
          <label for="dateDropdown">VGM Due Date:</label>
          <model-list-select :list="next7Days" id="VgmDueDateFilter" @input="debounceSearch"
            v-model="Filter.VgmDueDateFilter" option-value="value" option-text="label"
            placeholder="Select VGM Due Date" />
        </b-col>
      </b-row>

      <div class="mt-3">
        <!-- Search Form Input Start -->
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="Filter.commonFilter"
                  placeholder="Type to Search Assignment" ref="search" />
                <b-input-group-append class="mr-1">
                  <b-button :disabled="!Filter.commonFilter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>

              <b-col md="3">

              </b-col>
            </b-form-group>
          </b-col>

          <b-col md="5">

            <b-button class="pull-right ml-1" :variant="Filter.userFilter ||
              Filter.SiDueDateFilter ||
              Filter.TrDueDateFilter ||
              Filter.VgmDueDateFilter ||
              Filter.liner_bl_release_statusFilter ||
              Filter.line_inv_statusFilter ||
              Filter.commonFilter ||
              Filter.createdAtRange.startDate ||
              Filter.createdAtRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' pull-right mb-1' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.userFilter ||
                  Filter.SiDueDateFilter ||
                  Filter.TrDueDateFilter ||
                  Filter.VgmDueDateFilter ||
                  Filter.liner_bl_release_statusFilter ||
                  Filter.line_inv_statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdAtRange.startDate ||
                  Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>

            <b-button class="pull-right mb-1" v-if="ConsoleBookingList.length > 0"
              :disabled="ExcelBtnName !== 'Export As Excel'" @click="getReports('checkJobPendency', 'Export As Excel')"
              size="sm" variant="warning" style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small label="Small Spinner"></b-spinner>
            </b-button>
            <userBasedClient v-if="$sessionsStorage.get('userId')"
              :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')" :PMC_USERID="Filter.userFilter"
              :PMC_USERNAME="$sessionsStorage.get('nameUser')" :PMC_USERDESIG="$sessionsStorage.get('designation')"
              :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
              :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
              :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
              :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
          </b-col>

          <b-col md="1">
            <h5>
              <small v-if="!isLoading">{{ totalData }} Entries</small>
            </h5>
          </b-col>
        </b-row>

        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale"
                    @update="getUnUsedBookingList('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label v-if="activeUserPreference">
                    <b>Created User Filter</b>
                  </label>
                  <model-list-select v-if="activeUserPreference" :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter" @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                    option-text="employeeName" placeholder="Select Created User" />
                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">SI Due Date:</label>
                  <model-list-select :list="next7Days" id="SiDueDateFilter" @input="debounceSearch"
                    v-model="Filter.SiDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select SI Due Date" />

                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">TR Due Date:</label>
                  <model-list-select :list="next7Days" id="TrDueDateFilter" @input="debounceSearch"
                    v-model="Filter.TrDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select TR Due Date" />
                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">VGM Due Date:</label>
                  <model-list-select :list="next7Days" id="VgmDueDateFilter" @input="debounceSearch"
                    v-model="Filter.VgmDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select VGM Due Date" />
                </b-col>
                <b-col cols="3">
                  <label for="liner-bl-release-status">Liner BL Release Status</label>
                  <model-list-select :list="mblInvoiceStatus" @input="debounceSearch" id="liner_bl_release_status"
                    v-model="Filter.liner_bl_release_statusFilter" option-value="value" option-text="label"
                    placeholder="Select MBL Status" />
                </b-col>
                <b-col cols="3">
                  <label for="liner-bl-release-status">Line Invoice Status</label>
                  <model-list-select :list="lineInvoiceStatus" id="line_inv_status" @input="debounceSearch"
                    v-model="Filter.line_inv_statusFilter" option-value="value" option-text="label"
                    placeholder="Select Line Invoice Status" />
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
          :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
        <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">

          <b-table show-empty stacked="md" responsive :fields="columnMain" :items="ConsoleBookingList"
            class="table-background position-relative" :per-page="pagination.perPage" :filter="filter"
            @filtered="onFiltered">
            <!--  -->
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}</span>
            </template>
            <template slot="Bookingno" slot-scope="row1">

              <span>{{ "Booking Type : " + row1.item.BookingType }}</span><br />
              <span>{{ "Booking For : " + row1.item.Bookingfor }}</span><br />
              <span>{{ "Booking No : " + row1.item.Bookingno }}</span><br />
              <span>{{ "Contract No : " + row1.item.Contractno }}</span>
              <b-button size="sm" style="margin-left: auto; font-size: 0.675rem" class="ml-1" variant="outline-danger"
                @click="openModal(row1.item)">
                Update
              </b-button>
              <UpdateCBModal ref="updateCBModal" :common_id="row1.item.common_id" :allModuleId="row1.item.allModuleId"
                :JobNo="''" :booking_id="row1.item.booking_id" :getin_due_date="row1.item.cb_getin_due_date"
                :si_submission_date="row1.item.cb_si_submission_date"
                :vgm_submission_date="row1.item.cb_vgm_submission_date"
                :tr_submission_date="row1.item.cb_tr_submission_date"
                :liner_bl_release_status="row1.item.cb_liner_bl_release_status"
                :line_inv_status="row1.item.cb_line_inv_status" :linerBLNumber="''" :blType="''" :frghtTermsLiner="''"
                :linerBLupload="''" :mbl_release_date="''" :mbl_date="''" @update="updateData" />
            </template>
            <template slot="Remark" slot-scope="row2">

              <span>{{ "Remark : " + row2.item.Remark }}</span><br />
              <span>{{ "Close Remark : " + row2.item.ClosingReasontxt }}</span><br />
              <span>{{ "Closed By : " + row2.item.ClosedBy }}</span><br />
              <span>{{ "Remark : " + row2.item.Remark }}</span>
            </template>
            <template slot="VoyageNo" slot-scope="row3">
              <span>{{ "Voyage No : " + row3.item.VoyageNo }}</span><br />
              <span>{{ "Vessel Name : " + row3.item.VesselName }}</span>
            </template>
            <template slot="Branch" slot-scope="row4">
              <span>{{ "Branch : " + row4.item.Branch }}</span><br />
              <span>{{ "POR : " + row4.item.Por }}</span><br />
              <span>{{ "POL : " + row4.item.Pol }}</span><br />
              <span>{{ "POD : " + row4.item.Pod }}</span>
            </template>
            <template slot="ClientName" slot-scope="row5">
              <span>{{ "Client Name : " + row5.item.ClientName }}</span><br />
              <span>{{ "Sline Name : " + row5.item.SlineName }}</span><br />
              <span>{{ "Agent Name : " + row5.item.AgentName }}</span>
            </template>
            <template slot="CreatedBy" slot-scope="row6">
              <span>{{ "Created By : " + row6.item.CreatedBy }}</span><br />
              <span>{{ "Created At : " + row6.item.CreatedAt }}</span>
            </template>
            <template slot="UpdatedBy" slot-scope="row6">
              <span>{{ "Updated By : " + row6.item.UpdatedBy }}</span><br />
              <span>{{ "Updated At : " + row6.item.UpdatedAt }}</span>
            </template>
            <template slot="BrfNo" slot-scope="row10">
              <span>{{ "Enq No : " + row10.item.EnqNo }}</span><br />
              <span>{{ "Brf No : " + row10.item.BrfNo }}</span>
            </template>
            <template slot="ActiveStatus" slot-scope="row10">

              <div :id="'row' + row10.item.booking_id">
                <md-switch v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'" :id="'approval' + row10.item.booking_id"
                  name="approval" class="md-primary" :value="row10.item.isbookingactive == 1 ? true : false"
                  @change="activateBooking(row10.item)">
                  <h6>
                    <br />
                    <b-badge :variant="row10.item.isbookingactive == 1 ? 'success' : 'danger'">{{
                      row10.item.ActiveStatus }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <span>{{ "Active Status : " + row10.item.ActiveStatus }}</span><br />
              <span>{{ "BL Status : " + row10.item.Linerblreleasestatus }}</span><br />
              <span>{{ "Line Status : " + row10.item.Lineinvstatus }}</span><br />
              <span>{{ "From Booing Response : " + row10.item.FromBooingResponse }}</span>
            </template>
            <template slot="SiCutOff" slot-scope="row10">
              <span>{{ "Si Cut Off : " + row10.item.SiCutOff }}</span><br />
              <span>{{ "Si Due Date : " + row10.item.SiDueDate }}</span><br />
              <span>{{ "Si Submission : " + row10.item.cb_si_submission_date }}</span><br />
              <span>{{ "Vgm Due Date : " + row10.item.VgmDueDate }}</span><br />
              <span>{{ "Vgm Submission : " + row10.item.cb_vgm_submission_date }}</span><br />
              <span>{{ "Tr Due Date : " + row10.item.TrDueDate }}</span><br />
              <span>{{ "Tr Submission : " + row10.item.cb_tr_submission_date }}</span><br />
              <span>{{ "Get In Due Date : " + row10.item.GetInDueDate }}</span>
            </template>
            <template slot="ValidTill" slot-scope="row10">
              <span>{{ "Valid Till : " + row10.item.ValidTill }}</span><br />
              <span>{{ "Validity Start : " + row10.item.ValidityStart }}</span><br />
              <span>{{ "Validity End : " + row10.item.ValidityEnd }}</span><br />
              <span>{{ "Vessel Sail Start Date : " + row10.item.VesselSaleStartDate }}</span><br />
              <span>{{ "Vessel Sail End Date : " + row10.item.VesselSaleEnddate }}</span>
            </template>
            <!-- <template slot="ReleaseDate" slot-scope="row10">
              <span>{{ "Release Date : " + row10.item.ReleaseDate }}</span>

            </template> -->
          </b-table>
          <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
        </div>
      </div>

      <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </b-card>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE_DOC } from "../../helper/constant.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection.js";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import UpdateCBModal from '../Pendency/UpdateCBModal.vue';
import ClientUserService from "../../services/ClientUserService.js";

export default {
  beforeMount() {
    this.initializePage();
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  data() {
    return {
      isModalOpen: false,
      cb_data: {
        common_id: 0,
        allModuleId: 0,
        booking_id: 0,
        getin_due_date: '',
        si_submission_date: '',
        vgm_submission_date: '',
        tr_submission_date: '',
        liner_bl_release_status: 0,
        line_inv_status: 0,
      },

      ALLMODULE: "",
      JOBSERIES: "",
      visible: false,
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [100, 200, 300],
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      activeButtonBranch: this.$sessionsStorage.get("branchclientPre") === "1",
      Filter: {
        userFilter: "",// this.$sessionsStorage.get("userId"),
        SiDueDateFilter: "",
        TrDueDateFilter: "",
        VgmDueDateFilter: "",
        liner_bl_release_statusFilter: 0, line_inv_statusFilter: 0,
        commonFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",

      },

      columnMain: this.initializeColumns(),
      ConsoleBookingList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      debounce: null, // Debounce timer
      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      activeButtonBranch: this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      lineInvoiceStatus: [
        { label: "Not Received from Line", value: 1 },
        { label: "Not Initiated", value: 0 },
        { label: "Paid", value: 2 },
        { label: "Dispute Raised", value: 3 },
        { label: "Send for Payment", value: 4 }
      ],
      mblInvoiceStatus: [
        { label: "Released", value: 1 },
        { label: "Sailed - NOT RELEASED", value: 0 },
        { label: "NOT RELEASED", value: 2 },
      ],
    };
  },
  computed: {
    next7Days() {
      const dates = [];
      const today = new Date();
      dates.push({
        label: "Previous 7 Days",
        value: "-7"
      });
      for (let i = 0; i < 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        let label;
        if (i === 0) label = "Today";
        else if (i === 1) label = "Tomorrow";
        else label = date.toLocaleDateString("en-US", { weekday: 'long' }); // e.g., "Monday"
        // Construct the value in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        const formattedDateUlta = `${year}-${month}-${day}`;
        dates.push({
          label: `${label} (${formattedDate})`,
          value: formattedDateUlta // Formats as 'YYYY-MM-DD'
        });
      }
      return dates;
    }
  },
  components: {
    UpdateCBModal,
    userBasedClient,
    ModelListSelect,
    CustomLoader,

    DatePicker,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },

  methods: {
    activateBooking(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isbookingactive = this.itemObj.isbookingactive == 1 ? 0 : 1;
      let paylod = {
        tableName: "console_booking",
        tableId: "booking_id",
        tableIsActive: "isbookingactive",
        value1: this.itemObj.isbookingactive,
        tableVal: item.booking_id,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
          }

        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    openModal(item) {
      this.cb_data = {
        common_id: item.common_id,
        allModuleId: item.allModuleId,
        JOBNO:'',
        booking_id: item.booking_id,
        getin_due_date: item.cb_getin_due_date,
        si_submission_date: item.cb_si_submission_date,
        vgm_submission_date: item.cb_vgm_submission_date,
        tr_submission_date: item.cb_tr_submission_date,
        liner_bl_release_status: item.cb_liner_bl_release_status,
        line_inv_status: item.cb_line_inv_status,
        linerBLNumber: '',
        blType: '',
        frghtTermsLiner: '',
        linerBLupload: '',
        mbl_release_date:'',
        mbl_date:'',
        FBLCreatedBy: '',
        FBLloginTime: '',
        FBLupdatedBy: '',
        FBLupdateTime: '',
      };
      // console.log('this.cb_data=>', this.cb_data);
      // this.isModalOpen = true;
      this.$refs.updateCBModal.show(this.cb_data);
    },
    updateData(updatedData) {
      this.cb_data = updatedData;
      // console.log('updatedData=>', this.cb_data);
      // return false;
      NodeLockPannelService.updateUnUsedBookingStatus(this.cb_data)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log("data PS=>", data);

          if (status == 200 && data.status == true) {
            this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },

    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String("04").padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      // firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      firstDay = parseInt(firstDay_yyyy-1) + "/" + "11" + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      console.log('parseInt(firstDay_yyyy-1)=>',parseInt(firstDay_yyyy-1))

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
    },
    clearFilter() {
      this.Filter = {
        userFilter: "",//this.$sessionsStorage.get("userId"),
        SiDueDateFilter: "",
        TrDueDateFilter: "",
        VgmDueDateFilter: "",
        liner_bl_release_statusFilter: 0, line_inv_statusFilter: 0,
        commonFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
        isAllNo: 0,
        isSelectedColumn: 0,
      };
      this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
    },

    BranchBtnFilter(type) {
      this.activeButtonBranch = !type;

      this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
    },
    filterClear() {
      this.Filter = {
        userFilter: "",
      };
    },

    initializePage() {
      this.getCurrentLastDate();
      lastVisitPage(this.$router.history.current.fullPath);
      const loginId = this.$sessionsStorage.get("loginId");
      if (!loginId) return this.$router.push({ path: "/Login/" });

      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Sea Freight")) {
        this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
      } else {
        this.$router.push({ path: "/dashboard" });
      }

      this.$store.dispatch("common/setAllUserList", JSON.stringify({ itemCode: "GET_USERLIST_Data" }));
    },

    initializeColumns() {
      return [
        { key: "SN", mainkey: "SN", label: "SN.", sortable: true, table: "HJ." },
        { key: "Bookingno", mainkey: "Bookingno", label: "Booking Det.", sortable: true, table: "B." },
        { key: "Remark", mainkey: "Remark", label: "Remark", sortable: true, table: "C." },
        { key: "VoyageNo", mainkey: "VoyageNo", label: "Vessel Details", sortable: true, table: "D." },
        { key: "Branch", mainkey: "Branch", label: "Location Det.", sortable: true, table: "A." },
        { key: "ClientName", mainkey: "ClientName", label: "Other Det.", sortable: true, table: "I." },
        { key: "CreatedBy", mainkey: "CreatedBy", label: "Created By", sortable: true, table: "J." },
        { key: "UpdatedBy", mainkey: "UpdatedBy", label: "Updated By", sortable: true, table: "J." },
        { key: "BrfNo", mainkey: "BrfNo", label: "Enq/BRF No", sortable: true, table: "K." },
        { key: "ActiveStatus", mainkey: "ActiveStatus", label: "Status", sortable: true, table: "L." },
        { key: "SiCutOff", mainkey: "SiCutOff", label: "SI Cut-Off", sortable: true, table: "N." },
        { key: "ValidTill", mainkey: "ValidTill", label: "Valid Till", sortable: true, table: "N." },
        // { key: "ReleaseDate", mainkey: "ReleaseDate", label: "Release Date", sortable: true, table: "O." },

      ];
    },

    toggleBranchFilter(type) {
      this.activeButtonBranch = !type;
      this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
    },

    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.getUnUsedBookingList("Normal", "0", "0", "1", "1"), 500);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getUnUsedBookingList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getUnUsedBookingList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      // console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getUnUsedBookingList("Normal", "0", CURRENT, "2", event);
    },
    getUnUsedBookingList(type, filterId, currentPage, searchType, pageNumber) {
      this.totalData = 0;
      this.ConsoleBookingList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        record_type: "",
        activeButtonBranch: this.activeButtonBranch,
        isAllNo: this.generateExcel == '1' ? 1 : 0,
        isSelectedColumn: 0,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllUnUsedBookingList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log("data PS=>", data.data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Pendency-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalBookings;
                this.ConsoleBookingList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    goBack() {
      window.history.go(-1);
    },

    clearSearchFilter() {
      this.filter = "";
      this.getUnUsedBookingList("Normal", "0", "0", "1", "1");
    },
    shouldBlink: function (item) {
      return item.CustomColorColumn === "red";
    },
    isBlinking: function (item) {
      return item.CustomColorColumn === "red";
    },
  },
};
</script>

<style>
.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}

.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
}

.table-background>tbody {
  font-size: 11px;
}

.table-background>thead {
  color: black;
}

.status-alerts {
  font-size: 18px;
}

.alert-danger-text {
  color: #d9534f;
}

.alert-info-text {
  color: #2a6fde;
}

.blink {
  animation: blinker 1s linear infinite;
  font-weight: 800;
  color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// unusedBooking.vue?9a4afe80